<template>
    <div :class="`product-style-one ${productStyleClass} w-full p-5 rounded-xl relative z-10`">
        <div class="card-thumbnail overflow-hidden rounded-md relative -mx-4">
            <router-link :to="`/product/${productDate.id}`">
                <img :src="productDate.productImage" :alt="productDate.productName" @load="$emit('handleImageLoad')" class="rounded-md object-cover w-full h-auto transition-transform duration-500 hover:scale-110">
            </router-link>
            <countdown v-if="productDate.countdown" :date="productDate.countdown.date"/>
            <router-link v-if="showPlaceBid" :to="`/product/${productDate.id}`" class="btn btn-primary absolute top-1/2 left-1/3 transform scale-0 transition-transform duration-300 rounded py-2 px-3 hover:text-white">
                Place Bid
            </router-link>
        </div>
        <div class="product-share-wrapper flex justify-between items-center mt-8">
            <div class="profile-share flex items-center">
                <router-link v-for="(author, index) in productDate.authors"
                             :key="`author-${index}`"
                             :to="`/author/${author.id}`"
                             class="avatar relative z-10 transition-transform hover:z-20 hover:translate-y-[-3px] hover:scale-110"
                             :data-tooltip="author.name">
                    <img :src="author.image" :alt="author.name" class="max-w-[30px] rounded-full border-2 border-gray-600 transition-transform">
                </router-link>
                <router-link to="#" class="more-author-text text-gray-400 inline-block pl-2 hover:text-primary hover:transform-none">
                    {{ productDate.biddingAmount }}+ Place Bit.
                </router-link>
            </div>
            <div class="share-btn share-btn-activation dropdown relative z-10 h-9 flex items-center cursor-pointer transition-all">
                <button class="icon border-0 p-0 m-0" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="feather-more-horizontal"/>
                </button>
                <div class="share-btn-setting dropdown-menu dropdown-menu-end">
                    <button type="button"
                            class="btn-setting-text share-text"
                            data-bs-toggle="modal"
                            data-bs-target="#shareModal">
                        Share
                    </button>
                    <button type="button"
                            class="btn-setting-text report-text"
                            data-bs-toggle="modal"
                            data-bs-target="#reportModal">
                        Report
                    </button>
                </div>
            </div>
        </div>
        <router-link :to="`/product/${productDate.id}`">
            <span class="product-name block mt-3 font-medium text-lg transition-colors duration-400 hover:text-primary">{{ productDate.productName }}</span>
        </router-link>
        <span class="latest-bid mt-3 font-normal text-base text-left block">{{ productDate.latestBid }}</span>
        <div class="bid-react-area flex justify-between mt-3">
            <div class="last-bid font-semibold text-primary">{{ productDate.lastBid }}</div>
            <div class="react-area relative z-10 flex items-center transition-all cursor-pointer p-1 px-2 rounded-md hover:text-white" :style="{ '--after-bg': 'var(--color-primary-alta)' }">
                <i class="feather-heart mr-1 relative w-4"/>
                <span class="number text-sm relative">{{ productDate.reacted }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import Countdown from '@/components/product/Countdown';

export default {
    name: 'ProductCard',
    components: {Countdown},
    props: {
        productDate: {},
        productStyleClass: {
            type: String
        },
        showPlaceBid: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        '$route': function (to, from) {
            this.closeModal()
        }
    },
    methods: {
        closeModal() {
            const modals = document.querySelectorAll('.modal-backdrop');

            if (modals.length) {
                modals.forEach(item => {
                    item.remove();
                })
            }
        }
    }
}
</script>

<style scoped>
/* Preserve complex animations that Tailwind can't handle well */
.product-style-one {
    background: var(--background-color-4);
}

.product-style-one::before {
    content: '';
    position: absolute;
    top: auto;
    bottom: 0;
    left: 0;
    border-radius: 15px;
    background-image: linear-gradient(100deg, #13131d, #0398ed);
    background-repeat: repeat-x;
    transition: all .5s;
    width: 99%;
    height: 100%;
    z-index: -2;
}

.product-style-one::after {
    content: "";
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: #242435;
    position: absolute;
    border-radius: 10px;
    z-index: -1;
}

.product-style-one:hover::before {
    transform: rotate(2deg) translateX(-7px) translateY(11px);
}

.product-style-one.with-placeBid .card-thumbnail a,
.product-style-one.with-placeBid .card-thumbnail span.btn {
    position: absolute;
    top: 50%;
    left: 33%;
}

.product-style-one.with-placeBid:hover .card-thumbnail a,
.product-style-one.with-placeBid:hover .card-thumbnail span.btn {
    transform: scale(1) !important;
}

.card-thumbnail::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    background-image: linear-gradient(180deg, transparent, black);
    height: 50%;
    width: 100%;
    z-index: 1;
}

.product-style-one.no-overlay .card-thumbnail::before {
    display: none;
}

.react-area::after {
    background: var(--color-primary-alta);
    position: absolute;
    content: '';
    top: 0;
    z-index: -1;
    border-radius: 6px;
    transition: var(--transition);
    opacity: 0;
    width: 100%;
    left: 0;
    height: 100%;
}

.react-area:hover::after {
    opacity: 1;
    background: var(--color-primary);
}

.share-btn::after {
    position: absolute;
    content: '';
    height: 35px;
    width: 35px;
    background: var(--color-primary-alta);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -1;
    border-radius: 50%;
    transition: var(--transition);
    opacity: 0;
}

.share-btn:hover::after {
    opacity: 1;
}

.profile-share a:nth-child(2) {
    margin-left: -12px;
}

.profile-share a:nth-child(3) {
    margin-left: -12px;
}

.profile-share a:hover {
    transform: translateY(-3px) scale(1.1);
}

.hover\:text-primary:hover {
    color: var(--color-primary);
}

.hover\:scale-110:hover {
    transform: scale(1.1);
}

.hover\:translate-y-\[-3px\]:hover {
    transform: translateY(-3px);
}
</style>